.kz{color:var(--gray-900);}